import { Grid } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import DoneIcon from "@material-ui/icons/Done";
// import InsertChartTwoToneIcon from '@material-ui/icons/InsertChartTwoTone';
import GraphIcon from '@material-ui/icons/DonutSmall';
import EditIcon from '@material-ui/icons/Edit';
import ListIcon from '@material-ui/icons/List';
import NotesIcon from '@material-ui/icons/Notes';
import SearchIcon from "@material-ui/icons/Search";
import NotFeasibleIcon from '@material-ui/icons/ThumbDown';
import DesignIcon from '@material-ui/icons/ThumbUp';
import React, { useEffect, useState } from "react";
// import { getProcessedReports } from "../apis/tasks";
import { Doughnut, Bar } from 'react-chartjs-2';
import { getProcessedReports, getSubmissionsByTaskId } from "../apis/submissionsitems";
import { updateTask } from "../apis/tasks";
import { EFFORT, PRIORITY, STATUS } from '../constants';
import './dnd.css';
import './icons.css';
import { LightTooltip } from "./LightTooltip";
import Loading from "./Loading";
import useStyles from "./muistyles";
import { Table } from "../components/GenericReusableComponents/Table"



export default function ProcessReport(props) {
  const [selection, setSelection] = useState(3)

  const [processReports, setProcessReports] = useState([]);
  const [filteredProcessReports, setFilteredProcessReports] = useState([]);
  const [q, setQ] = useState("");
  const [showAddProcessReportForm,setShowAddProcessReportForm] = useState(false);
  const [showDelProcessReportModal,setShowDelProcessReportModal] = useState(false);
  const [taskTobeDel,setProcessReportTobeDel] = useState({});
  const [taskTobeUpdt,setProcessReportTobeUpdt] = useState({});
  const [showUpdtProcessReportModal,setShowUpdtProcessReportModal] = useState(false);
  const [processReportsChanged,setProcessReportsChanged] = useState(false);
  const [refreshToggle,setRefreshToggle] = useState(false);
  const [graphicalView,setGraphicalView] = useState(true);
  const [tableView,setTableView] = useState(true);
  const [loading, setLoading] = useState(true);
  const [processItemInEdit,setProcessItemInEdit] = useState({});

  
  const designerIconStyle = {
    backgroundImage:'linear-gradient(to bottom, grey, royalblue)', color:'white', padding:'5px', borderRadius:'10px'
  }

  const classes = useStyles();
  
  
  useEffect(() => {
    console.log("Inside Process Reports UseEffect");
    let mounted = true;
    if(processReports.length && !processReportsChanged){
      console.log("processReportsChanged :"+processReportsChanged)
      return;
    }
  
   
      console.log("Calling getProcessedReports");
      getProcessedReports(props.processId)
      .then((tasks)=>{
        if (mounted) {
          console.log("Reports inside useEffect");
          console.log(tasks);
          setProcessReports(tasks);
          let fProcessReport = [];
          tasks.forEach((x)=>fProcessReport.push(x));
          setFilteredProcessReports(fProcessReport);
        }
        setLoading(false)
      });
    
    return () => {console.log("ProcessReport is unmounted"); mounted = false};
  }, [processReports,processReportsChanged]);

  // async function  processTaskReports(task,lprocessReports){
  //   console.log("Inside deriveValuesFromSubmissions");
  //   let derivedValues ={};
  //   var count = 0;
  //   var frequency = 0;
  //   var timeTaken = 0;
  //   return getSubmissionsByTaskId(task.taskId).then((submissions) =>  {
  //       console.log("Inside getSubmissionsByTaskId");
  //       let submissionsData = submissions.data;
  //       var display= false;
  //       submissionsData.forEach((submission) => {
  //         console.log("Inside foreach submission");
  //         if (submission.status != 'Open'){
  //           count = count + 1;
  //           frequency = frequency + parseInt(submission.frequency);
  //           timeTaken = parseInt(submission.timeTaken) + timeTaken;
  //           display = true;
  //         }
  //       });
      
  //       if (display == true){
  //         task.submissions = count;
  //         task.frequency = frequency/count;
  //         task.timeTaken = timeTaken/count;
  //         console.log(">>>>>>" + task.timeTaken)
  //       // TODO: Need to add timeTaken to the equation
  //         // task.annualCostTime = ( derivedValues.frequency * derivedValues.userCount * 240)/60;
  //         // task.annualCostDollars = derivedValues.costperhour * derivedValues.annualCostTime;
  //         task.annualCostTime = ( task.frequency * task.userCount * 240)/60;
  //         task.annualCostDollars = task.costperhour * task.annualCostTime;

  //       }else{
  //         task.status = 'Open';
  //         task.submissions = "Not Calculated";
  //         task.frequency = "Not Calculated";
  //         task.timeTaken = "Not Calculated";
  //         task.annualCostTime = "Not Calculated";
  //         task.annualCostDollars = "Not Calculated";


  //       }

      
        
        
     
  //   });

  

  // }


  function getTableHeader(){
    return(
      <>
      <LightTooltip title="Task against which submissions are being considered">
      <th>Task Name</th>
      </LightTooltip>
     
      {/* <LightTooltip title="Date the Task Recordings were initiated">
      <th style={{width:"100px"}}>Start Date</th>
      </LightTooltip>
      <LightTooltip title="Deadline for the Task submissions">
      <th style={{width:"100px"}}>End Date</th>
      </LightTooltip> */}
      <LightTooltip title="Total Number of Submissions for this Task">
      <th>Submissions</th>
      </LightTooltip>
      <LightTooltip title="Total users working on this task">
      <th>Users</th>
      </LightTooltip>
      <LightTooltip title="Time taken by the user to do the task">
      <th>Time Taken</th>
      </LightTooltip>
      <LightTooltip title="Average Number of times task is done every day by each user">
      <th>Frequency</th>
      </LightTooltip>

      <LightTooltip title="Approximate cost per hour paid for this task">
      <th>Hourly Rate</th>
      </LightTooltip>

      <LightTooltip title="Total time spent on this task in a year">
      <th>Annual Cost</th>
      </LightTooltip>

      {/* <LightTooltip title="Total cost in dollars over a year, for this task">
      <th>Annual Cost</th>

      </LightTooltip> */}

      <LightTooltip title="Priority defined by the business">
      <th>Priority</th>
      </LightTooltip>

      <LightTooltip title="Effort sizing by RPA expert">
      <th>Effort</th>
      </LightTooltip>

      <LightTooltip title="Status">
      <th>Status</th>
      </LightTooltip>

      <LightTooltip title="Promote or Reject, Add Notes">
      <th>Actions</th>
      </LightTooltip>
      </>
    )
  }

  function getTableBody(){
    return (

      filteredProcessReports.map((processItem) => (
        <tr>
          <td>{processItem.taskName}</td>
          
          {/* <td>{processItem.startDate}</td>

          <td>{processItem.endDate}</td> */}
          <td>{processItem.submissions}</td>
          <td>{processItem.userCount}</td>
          <td>{processItem.timeTaken}</td>
          <td>{processItem.frequency}</td>
          <td>{"$" + processItem.costperhour}</td>
          {/* <td>{"$" + processItem.annualCostDollars + " (" + processItem.annualCostTime + " hrs)" }</td> */}
          <td>{ processItem.annualCostDollars == undefined? "(TBD)": "$" + processItem.annualCostDollars  + " (" + processItem.annualCostTime + " hrs)" }</td>

          <td>{getPriority(processItem)}</td>
          <td>{getEffort(processItem)}</td>
          <td>{processItem.status}</td>
          <td style={{width : "200px"}}>
         
           {getActions(processItem)}
          </td>
        </tr>
      ))
    )
  }


  function refreshView(){
    console.log("refresh view "+refreshToggle);
    if(refreshToggle == false)
      setRefreshToggle(true);
    else
      setRefreshToggle(false);
  }


  function filterTable(filterString) {
    console.log(filterString);
    let trimStr = filterString.trim();
    if (trimStr === "") {
      setFilteredProcessReports(processReports);
      setQ("");
    } else {
      setQ(filterString);
      setFilteredProcessReports(
        processReports.filter((task) => {
          if (task.taskName.startsWith(filterString)) return true;

          if (task.description.startsWith(filterString)) return true;

          if (task.priority.startsWith(filterString)) return true;


          if (task.status.startsWith(filterString)) return true;

          console.log("no match ");
          console.dir(task);
        })
      );
    }
  }

  function setProcessItemsChangedTrigger(bool){
    console.log("setProcessItemsChanged "+bool)
    setProcessReportsChanged(bool);
  }



  function promoteToDesign(e, processItem){
    processItem.status = STATUS.PROMOTED.string;
    let task = {};
    task.taskId = processItem.taskId;
    task.taskName = processItem.taskName;
    task.status = processItem.status;
    task.description = processItem.description;
    task.endDate = processItem.endDate;
    task.priority = processItem.priority;
    task.userCount = processItem.userCount;
    task.costperhour = processItem.costperhour;
    updateTask(task);
    // setProcessReportsChanged(true);
    updateProcessItemState(processItem);
    //promoteTask(processItem.taskName)
    // getSubmissionsForTask(processItem.taskName)
    // data = {submissionId: }
    // apiPost(url, data)
  }

  function reject(e, processItem){
    processItem.status = STATUS.REJECTED.string;
    // let task = {};
    // task.taskId = processItem.taskId;
    // task.taskName = processItem.taskName;
    // task.status = processItem.status;
    // task.description = processItem.description;
    // task.endDate = processItem.endDate;
    // task.priority = processItem.priority;
    // task.userCount = processItem.userCount;
    // task.costperhour = processItem.costperhour;
    let task = getTaskFromProcessItem(processItem);
    updateTask(task);
    // setProcessReportsChanged(true);
    updateProcessItemState(processItem);

    // setProcessReportsChanged(true);


  }

  function getTaskFromProcessItem(processItem){
    let task = {};
    task.taskId = processItem.taskId;
    task.taskName = processItem.taskName;
    task.status = processItem.status;
    task.description = processItem.description;
    task.endDate = processItem.endDate;
    task.priority = processItem.priority;
    task.userCount = processItem.userCount;
    task.costperhour = processItem.costperhour;
    return task;
  }

  function notes(e, processItem){
    
  }


  function setShow(bool){
    setShowAddProcessReportForm(bool);
  }

  function setShowDel(bool){
    setShowDelProcessReportModal(bool);
  }

  function setShowUpdt(bool){
    setShowUpdtProcessReportModal(bool);
  }
  //temporarily duplicating the code. reuse later
  function getStatusStyle(status){
    var statusStyle = "status";
    switch (status){
      case "INACTIVE":
        statusStyle = statusStyle + " statusInactive";
        break;
      case "DISABLED":
        statusStyle = statusStyle + " statusDisabled";
        break;

      default: statusStyle = statusStyle + " statusActive"
    }
    return statusStyle;
  }

  function getToolTipForThumbUp(processItem){
    if(processItem.status === "Active"){
      return "Move to Planning";
    }

    if(processItem.status === "Planning"){
      return "Move to Design";
    }

    if(processItem.status === "Planning"){
      return "Move to Promoted";
    }


  }

  function prioritySelected(e,processItem){
    // processItem.makeRowEditable = false;
    // processItem.priority = e.target.value;
    let lprocessInEdit = {...processItemInEdit};
    lprocessInEdit.priority = e.target.value;
    setProcessItemInEdit(lprocessInEdit);
    // updateProcessItemState(processItem);
  }

  function getPriority(processItem){
    if(processItem.makeRowEditable){
      return (
        <Select defaultValue={processItem.priority} onChange={(e)=>prioritySelected(e,processItem)}>
        <MenuItem value="CRITICAL" >CRITICAL</MenuItem>
        <MenuItem value="HIGH">HIGH</MenuItem>
        <MenuItem value="MEDIUM">MEDIUM</MenuItem>  
        <MenuItem value="LOW">LOW</MenuItem>      
      </Select>
      )
    }else{
      return processItem.priority;
      
    }
  }

  function effortSelected(e,processItem){
    let lprocessInEdit = {...processItemInEdit};
    lprocessInEdit.effort = e.target.value;
    setProcessItemInEdit(lprocessInEdit);
    
  }

  function getEffort(processItem){
    if(processItem.makeRowEditable){

      return (
        <Select defaultValue={processItem.effort} onChange={(e)=>effortSelected(e,processItem)}>
            <MenuItem value="SMALL" >SMALL</MenuItem>
            <MenuItem value="MEDIUM">MEDIUM</MenuItem>
            <MenuItem value="LARGE">LARGE</MenuItem>       
          </Select>
      )

    }else{
      return processItem.effort;
      
    }


  }

  function updateProcessItemState(processItem){
    var lprocessReports = [...processReports];
    let i = lprocessReports.findIndex((p)=>p.taskId === processItem.taskId)
    lprocessReports[i] = {...processItem};
    setFilteredProcessReports(lprocessReports);
    setProcessReports(lprocessReports);
    
  }

  function handleClickOnEdit(e,processItem){
    processItem.makeRowEditable = true;
    setProcessItemInEdit({...processItem});
    updateProcessItemState(processItem);
    
  }

  function update(e,processItem){
    
    var lprocessItemInEdit = {...processItemInEdit};
    lprocessItemInEdit.makeRowEditable = false;
    updateProcessItemState(lprocessItemInEdit);
    let task = {};
    task = getTaskFromProcessItem(lprocessItemInEdit);
    task.effort = lprocessItemInEdit.effort;
    task.priority = lprocessItemInEdit.priority;

    updateTask(task);
   
   
    setProcessItemInEdit({});
  }

  function cancel(e,processItem){
   
    processItem.makeRowEditable = false;
    updateProcessItemState(processItem);
    setProcessItemInEdit({});
  }


  function getActions(processItem){
    if(processItem.makeRowEditable){
      return (
        <>
      <LightTooltip title="Update">
        <IconButton  onClick={(e)=>update(e,processItem)}>
          <DoneIcon  />
        </IconButton>
      </LightTooltip>

      <LightTooltip title="Cancel">
        <IconButton  onClick={(e)=>cancel(e,processItem)}>
          <CloseIcon  />
        </IconButton>
      </LightTooltip>
      </>
      )
    }else{
      return (
        <>
        <LightTooltip title="Promote">
        <IconButton className="toolbutton" onClick={(e)=>promoteToDesign(e,processItem)}>
          <DesignIcon className='roundButton'  />
        </IconButton>
        </LightTooltip>

        <LightTooltip title="Reject">
        <IconButton  className="toolbutton" onClick={(e)=>reject(e,processItem)}>
          <NotFeasibleIcon  className='roundButton'  />
        </IconButton>
        </LightTooltip>

        <LightTooltip title="Edit Effort">
        <IconButton  className="toolbutton" onClick={(e)=>handleClickOnEdit(e,processItem)}>
          <EditIcon className='roundButton'  />
        </IconButton>
        </LightTooltip>

        {/* <LightTooltip title="Notes">
        <IconButton onClick={(e)=>notes(e,processItem)}>
          <NotesIcon className='roundButton'  />
        </IconButton>
        </LightTooltip> */}
        </>
      )
    }
  }

 



   

   if(graphicalView){
     console.log("Inside graphical view");

    
    
    let stats = [];
    for (let i = 0; i < 12; i++) { //initialize
      stats.push(0);
    }

    if(processReports.length != 0){
        stats = processReports.reduce((newArr,task)=>{
        if(task.status === STATUS.REJECTED.string){
            newArr[STATUS.REJECTED.value] =  newArr[STATUS.REJECTED.value]+ 1;
            return newArr;
        }

        if(task.effort === undefined){
          newArr[EFFORT.NOEFFORT.value] = newArr[EFFORT.NOEFFORT.value] + 1;
        }
        if(task.effort === EFFORT.SMALL.string){
          newArr[EFFORT.SMALL.value] = newArr[EFFORT.SMALL.value] + 1;
        }
        if(task.effort === EFFORT.MEDIUM.string){
          newArr[EFFORT.MEDIUM.value] = newArr[EFFORT.MEDIUM.value] + 1;
        }
  
        if(task.effort === EFFORT.LARGE.string){
          newArr[EFFORT.LARGE.value] =  newArr[EFFORT.LARGE.value]+ 1;
        }
  
        if(task.priority === PRIORITY.CRITICAL.string){
          newArr[PRIORITY.CRITICAL.value] =  newArr[PRIORITY.CRITICAL.value]+ 1;
        }
  
        if(task.priority ===  PRIORITY.HIGH.string){
          newArr[PRIORITY.HIGH.value] =  newArr[PRIORITY.HIGH.value]+ 1;
          
        }
  
        if(task.priority === PRIORITY.MEDIUM.string){
  
          newArr[PRIORITY.MEDIUM.value] =  newArr[PRIORITY.MEDIUM.value]+ 1;
          
        }
  
        if(task.priority === PRIORITY.LOW.string){
          newArr[PRIORITY.LOW.value] =  newArr[PRIORITY.LOW.value]+ 1;
          
        }
  
        if(task.status === "Active"){ //TODO change it enum
          newArr[STATUS.ACTIVE.value] =  newArr[STATUS.ACTIVE.value]+ 1;
        }
  
        if(task.status === STATUS.PLANNING.string){
          newArr[STATUS.PLANNING.value] =  newArr[STATUS.PLANNING.value]+ 1;
          
        }
  
        if(task.status === STATUS.PROMOTED.string){
          newArr[STATUS.PROMOTED.value] =  newArr[STATUS.PROMOTED.value]+ 1;
          
        }
  
       
  
        return newArr;
      },stats)
    }   
  
    console.log("Stats "+ JSON.stringify(stats));
    console.log(stats[EFFORT.SMALL.value]);
  
    const data1 = {
      labels: ['Small', 'Medium', 'Large','No Estimate'],
      datasets: [
        {
          label: 'Dataset 1',
          // data: Utils.numbers(NUMBER_CFG),
          data:[stats[EFFORT.SMALL.value], stats[EFFORT.MEDIUM.value], stats[EFFORT.LARGE.value],stats[EFFORT.NOEFFORT.value]],
          backgroundColor:['royalblue', '#8da5ed', 'lavender','#feb100']
          // backgroundColor: Object.values(Utils.CHART_COLORS),
        }
      ]
    };


    const title1 = "Opportunity - Level of Effort";
  
    const data2 = {
      labels: ['Critical', 'High', 'Medium', 'Low'],
      datasets: [
        {
          label: 'Dataset 1',
          // data: Utils.numbers(NUMBER_CFG),
          data:[stats[PRIORITY.CRITICAL.value], stats[PRIORITY.HIGH.value], stats[PRIORITY.MEDIUM.value],stats[PRIORITY.LOW.value]],
          backgroundColor:['#feb100', '#8da5ed', 'royalblue', 'lavender']
          // backgroundColor: Object.values(Utils.CHART_COLORS),
        }
      ]
    };
    const title2 = "Opportunity - Priority"
  
    const data3 = {
      labels: ['Active', 'Planning', 'Promoted', 'Rejected'],
      datasets: [
        {
          label: 'Dataset 1',
          // data: Utils.numbers(NUMBER_CFG),
          data:[stats[STATUS.ACTIVE.value], stats[STATUS.PLANNING.value], stats[STATUS.PROMOTED.value], stats[STATUS.REJECTED.value]],
          backgroundColor:['royalblue', '#b8d2c8', 'lavender', '#feb100']
          // backgroundColor: Object.values(Utils.CHART_COLORS),
        }
      ]
    };

    

    const title3 = "Opportunity - Status"
  
    var data4=data1
    var data5=data2
    var data6=data3



    return (

      <Paper className={classes.donutpaper}>
        <LightTooltip title="Tabular view">
          <IconButton
            variant="contained"
            color="primary"
            size="medium"
            className={classes.iconbutton}
            onClick={() => {
              setTableView(true);
              setGraphicalView(false);
            }}
          >
            <ListIcon fontSize="large" style={designerIconStyle} />
          </IconButton>
        </LightTooltip>
        {/* <p/>
        <label style={{padding:'5px', backgroundColor:'#bababa', color:'white', fontSize:'18px'}}>{props.processName}</label>
        <p/> */}

        <div id="chart" className="chart-container">
          <div>
            <h3 className="title">{title1}</h3>
            <Doughnut data={data1} />
          </div>
  
          <div>
            <h3 className="title">{title2}</h3>
            <Doughnut data={data2} />
          </div>
  
          <div>
            <h3 className="title">{title3}</h3>
            <Doughnut data={data3} />
          </div>
        </div>

        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        
        <div id="chart2" className="chart-container">
          <div>
            <h3 className="title">{title1}</h3>
            <Bar data={data4} />
          </div>
  
          <div>
            <h3 className="title">{title2}</h3>
            <Bar data={data5} />
          </div>
  
          <div>
            <h3 className="title">{title3}</h3>
            <Bar data={data6} />
          </div>
        </div>


      </Paper>
    );
  }    
 if(tableView) {
  return (
    
      // <Paper elevation={1} className={classes.paper}>
     
      //    {/* <div style={{marginLeft:'6%',marginRight:'2%'}}> */}
      <>
        <Loading loading={loading}/>

          
          <LightTooltip title="Graphical view">
          <IconButton variant="contained"
            color="primary" size="medium" className={classes.iconbutton} onClick={()=>{
              setGraphicalView(true);
              setTableView(false); 
              }}>
            {/* <InsertChartTwoToneIcon fontSize="large"/> */}
            <GraphIcon fontSize="large" style={designerIconStyle}/>
          </IconButton>
          </LightTooltip>
         
        {/* <p/>
        <label style={{padding:'5px', backgroundColor:'#bababa', color:'white', fontSize:'18px'}}>{props.processName}</label>
        <p/> */}
             
        <Table 
          search={filterTable} 
          columns={getTableHeader()} 
          rows={getTableBody()}
          tbcontainerstyle={{margin:'0px',padding:'0px'}}
          
          />
  
    {/* </div> */}
    
  </>
    );
  }


}